class ProductStickyAnimate extends HTMLElement {
  constructor() {
    super();
  }

  _intersectionOberser = null;

  _BuyButtonWrapperElement = null;

  connectedCallback() {
    this._BuyButtonWrapperElement = document.querySelector(
      ".js-product-sticky-animate-sentinel",
    );

    if (!this._BuyButtonWrapperElement) return;

    this._intersectionOberser = new IntersectionObserver(
      this.observerCallback.bind(this),
      {
        rootMargin: "-120px 0px 0px 0px",
      },
    );

    this._intersectionOberser.observe(this._BuyButtonWrapperElement);
  }

  disconnectedCallback() {
    this._intersectionOberser?.disconnect();
  }

  observerCallback(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        requestAnimationFrame(this.reset.bind(this));
      } else {
        requestAnimationFrame(this.reveal.bind(this));
      }
    });
  }

  reveal() {
    this.setAttribute("animate", "");
  }

  reset() {
    this.removeAttribute("animate");
  }
}

customElements.define("product-sticky-animate", ProductStickyAnimate);
